var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-add-ons" },
    [
      _c(
        "div",
        { staticClass: "booking-add-ons-wrapper" },
        [
          _c("div", { staticClass: "booking-add-ons-header" }, [
            _c("div", [
              _c("h2", { staticClass: "booking-add-ons-header-title" }, [
                _vm._v("\n          " + _vm._s(_vm.title) + "\n        "),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "booking-add-ons-header-description" }, [
                _vm._v("\n          " + _vm._s(_vm.description) + "\n        "),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "booking-add-ons-header-counter",
                attrs: { role: "status" },
              },
              [_vm._v("\n        " + _vm._s(_vm.totalSelected) + "\n      ")]
            ),
          ]),
          _vm._v(" "),
          _c("BookingAddOnsCarousel", {
            attrs: { "add-ons-list": _vm.addOnsList },
            on: {
              "select-add-on": function ($event) {
                return _vm.selectAddOn($event, false)
              },
              "edit-add-on": function ($event) {
                return _vm.selectAddOn($event, true)
              },
              "remove-add-on": _vm.removeAddOn,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "slide-right" } },
        [
          _vm.selectedAddOn
            ? _c("booking-add-ons-sidebar", {
                attrs: {
                  "is-editing": _vm.isEditing,
                  "outer-activator": _vm.activator,
                },
                on: {
                  done: _vm.enhancementEdited,
                  deactivate: _vm.closeSidebar,
                },
                model: {
                  value: _vm.selectedAddOn,
                  callback: function ($$v) {
                    _vm.selectedAddOn = $$v
                  },
                  expression: "selectedAddOn",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.selectedAddOn
          ? _c("div", {
              staticClass: "backlight",
              on: { click: _vm.closeSidebar },
            })
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }